import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { crmApi } from "../../lib/crmApi";

export default function CrmLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await crmApi.staffLogin(email.trim(), password);
      navigate("/admin/crm", { replace: true });
    } catch (e2) { setErr(e2.message); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#1C110C] flex items-center justify-center px-4">
      <div className="w-full max-w-sm bg-[#FAF5EC] border border-[#6E1F2C]/20 p-8">
        <p className="font-serif-display text-xl tracking-[0.18em] text-[#6E1F2C] uppercase text-center">Time · Furniture</p>
        <p className="text-[9px] tracking-[0.32em] uppercase text-[#A6822F] text-center mt-1 mb-8">AI Sales CRM — Staff Login</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-[9px] tracking-[0.24em] uppercase text-[#7A6B5F] mb-1">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="crm-login-email"
              className="w-full bg-white border border-[#6E1F2C]/20 px-3 py-2.5 text-sm focus:outline-none focus:border-[#6E1F2C]"
            />
          </div>
          <div>
            <label className="block text-[9px] tracking-[0.24em] uppercase text-[#7A6B5F] mb-1">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="crm-login-password"
              className="w-full bg-white border border-[#6E1F2C]/20 px-3 py-2.5 text-sm focus:outline-none focus:border-[#6E1F2C]"
            />
          </div>
          {err && <p className="text-xs text-[#A3141A]" data-testid="crm-login-error">{err}</p>}
          <button
            type="submit"
            disabled={busy}
            data-testid="crm-login-submit"
            className="w-full bg-[#6E1F2C] text-[#FAF5EC] py-3 text-[10px] tracking-[0.3em] uppercase hover:bg-[#56151F] disabled:opacity-60"
          >
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <p className="text-[10px] text-[#7A6B5F] text-center mt-6">
          Admin? <Link to="/admin/login" className="text-[#6E1F2C] underline underline-offset-2">Use the admin login</Link>
        </p>
      </div>
    </div>
  );
}
